import { AgentType, ModelProvider } from '@rematter/frontend-lib-api-client';

import { agentFragment } from './fragmentsAgent';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const agentCreateMutationAtom = createMutationAtomFactory(
  'admin.agentCreate',
  (params: {
    name: string;
    content: string;
    description?: string;
    type: AgentType;
    agentIdentifier?: string;
    organizationId?: string;
    // AI Model Configuration
    modelProvider?: ModelProvider;
    model?: string;
    providerApiKey?: string;
    providerBaseUrl?: string;
    reasoningEnabled?: boolean;
    reasoningBudget?: number;
    temperature?: number;
  }) => ({
    assistantCreateAgent: {
      __args: {
        input: {
          name: params.name,
          content: params.content,
          description: params.description,
          type: params.type,
          agentIdentifier: params.agentIdentifier,
          organizationId: params.organizationId,
          // AI Model Configuration
          modelProvider: params.modelProvider,
          model: params.model,
          providerApiKey: params.providerApiKey,
          providerBaseUrl: params.providerBaseUrl,
          reasoningEnabled: params.reasoningEnabled,
          reasoningBudget: params.reasoningBudget,
          temperature: params.temperature,
        },
      },
      ...agentFragment,
    },
  }),
);
